/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamTypeListValuePreviewViewModel } from "../types/ExamTypeListValuePreviewViewModel.ts";

export const examTypeListValuePreviewViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da alternativa da questão.")),
  value: z
    .string()
    .describe("Texto da alternativa exibido ao aluno. Opcional.")
    .nullish(),
  checked: z.optional(
    z
      .boolean()
      .describe(
        "Indica se esta alternativa está marcada como selecionada na visualização prévia.",
      ),
  ),
}) as unknown as ToZod<ExamTypeListValuePreviewViewModel>;
